import { render, staticRenderFns } from "./RM_loss_attachment-modal.vue?vue&type=template&id=f376de72&scoped=true"
import script from "./RM_loss_attachment-modal.vue?vue&type=script&lang=js"
export * from "./RM_loss_attachment-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f376de72",
  null
  
)

export default component.exports